
import DataMapper from '../DataMapper'
import HospitalInfraInvestigatorRM from '../../responsemodel/ReportRM/HospitalInfraInvestigatorRM'
import InsuredInvestigator from '../../../models/ReportModels/InsuredInvestigator'

export default class InsuredInvestigatorDataMapper extends DataMapper<HospitalInfraInvestigatorRM, InsuredInvestigator> {
    map = (rm: HospitalInfraInvestigatorRM) => new InsuredInvestigator(rm._id, rm.claim_number, rm.modified_on, rm.name)
}
